import { Icon } from "@chakra-ui/react"
import { HiDotsVertical } from '@react-icons/all-files/hi/HiDotsVertical';

export const VerticalDotsIcon = (props: any) => (
  <Icon as={HiDotsVertical} color="#06BCC1" {...props} />
);
